import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosInstance from "../../../Config/AxiosInstance";
import APILIST from "../../../Config/ApiList";

export const LOGIN_USER = createAsyncThunk('auth/login', async (user) => {
    try {
        const response = await AxiosInstance.post(APILIST.LOGIN_API, user);
        return response.data;
    } catch (error) {
        throw error.response.data;
    }
})
export const FORGOT_PASSWORD = createAsyncThunk('auth/forgot-passwprd', async (user) => {
    try {
        const response = await AxiosInstance.post(APILIST.FORGOT_PASSWORD, user);
        return response.data;;
    } catch (error) {
        throw error.response.data;
    }
})